import React, { useState } from "react";
import "./Leaveform.css";
import MobileLayout from "../../../layouts/MobileLayout";




const LeaveForm = () => {
    const [leaveType, setLeaveType] = useState("");
    const [showLeaveTypes, setShowLeaveTypes] = useState(false);

    const [date, setDate] = useState();

    const [duration, setDuration] = useState("");
    const [reason, setReason] = useState("");


    const leaveOptions = [
        "Casual Leave",
        "Sick Leave",
        "Privilege Leave",
        "Birthday Leave",
    ];

    const handleApplyLeave = () => {
        const payload = {
            leaveType,
            date,
            duration,
            reason,
        };

        console.log("Leave Application:", payload);

        alert("Leave Applied Successfully");
    };

    return (
        <MobileLayout>
        <div className="leave-form-page">
            <h2 className="leave-form-title">
                Leave Application
            </h2>

            <div className="leave-form-group">
                <label className="leave-form-label">
                    Type of Leave
                </label>

                <div className="leave-form-dropdown">
                    <div
                        className="leave-form-select"
                        onClick={() =>
                            setShowLeaveTypes(!showLeaveTypes)
                        }
                    >
                        <span>
                            {leaveType || "Select a leave type"}
                        </span>

                        <span className="leave-dropdown-arrow">
                            {showLeaveTypes ? "▲" : "▼"}
                        </span>
                    </div>



                    {showLeaveTypes && (
                        <div className="leave-form-options">
                            {leaveOptions.map((option) => (
                                <div
                                    key={option}
                                    className="leave-form-option"
                                    onClick={() => {
                                        setLeaveType(option);
                                        setShowLeaveTypes(false);
                                    }}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="leave-form-group">
                <label className="leave-form-label">
                    Date
                </label>

                <input
                    type="date"
                    className="leave-form-date-input"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                />
            </div>

            <div className="leave-form-group">
                <label className="leave-form-label">
                    Duration
                </label>

                <div className="leave-form-duration">
                    <label className="leave-form-radio">
                        <input
                            type="radio"
                            name="duration"
                            value="First Half"
                            checked={
                                duration === "First Half"
                            }
                            onChange={(e) =>
                                setDuration(e.target.value)
                            }
                        />
                        First Half
                    </label>

                    <label className="leave-form-radio">
                        <input
                            type="radio"
                            name="duration"
                            value="Second Half"
                            checked={
                                duration === "Second Half"
                            }
                            onChange={(e) =>
                                setDuration(e.target.value)
                            }
                        />
                        Second Half
                    </label>

                    <label className="leave-form-radio">
                        <input
                            type="radio"
                            name="duration"
                            value="Full Day"
                            checked={
                                duration === "Full Day"
                            }
                            onChange={(e) =>
                                setDuration(e.target.value)
                            }
                        />
                        Full Day
                    </label>
                </div>
            </div>

            <div className="leave-form-group">
                <label className="leave-form-label">
                    Reason
                </label>

                <textarea
                    className="leave-form-reason"
                    placeholder="Start typing here..."
                    value={reason}
                    onChange={(e) =>
                        setReason(e.target.value)
                    }
                />
            </div>

            <button
                className="leave-form-submit"
                onClick={handleApplyLeave}
            >
                Apply Leave
            </button>
        </div>
        </MobileLayout>
    );
};

export default LeaveForm;